import { useCheckAuth } from "./hooks/useCheckAuth";
import { useAuth } from "./context/authContext";

const AppInitializer = ({ children }) => {
  useCheckAuth(); 
  return children;
};

export default AppInitializer;